import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Layout } from './layouts/Layout';

export default function Router() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
